import axios from "axios";
import React, { useState, useEffect } from "react";
import { FaUndo } from "react-icons/fa";
import { FiSearch } from "react-icons/fi";
import { IoExitOutline } from "react-icons/io5";
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { API_HOST } from "../api_utils";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

function Logs(props) {
  const { userDataFromStorage, coloredTheme } = props;
  const [logList, setLogList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [currentData, setCurrentData] = useState([]);

  // states for filter:
  const [userName, setUserName] = useState("");
  const [logAfter, setLogAfter] = useState("");
  const [logBefore, setLogBefore] = useState("");
  const [actionArea, setActionArea] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const getLogsApiCall = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    let apiUrl = `${API_HOST}/api/microloan_logs?page=${currentPage}&pageSize=${pageSize}`;

    const queryParams = [];
    if (userName) {
      queryParams.push(`user_name=${userName}`);
    }
    if (logAfter) {
      queryParams.push(`log_after=${logAfter}`);
    }
    if (logBefore) {
      queryParams.push(`log_before=${logBefore}`);
    }
    if (actionArea) {
      queryParams.push(`action_area=${actionArea}`);
    }

    if (queryParams.length > 0) {
      const queryString = queryParams.join("&");
      apiUrl += `&${queryString}`;
    }

    const { data } = await axios.get(apiUrl, config);

    if (data.message) {
      setLoading(false);
      toast.error(data.message);
    } else {
      setLoading(false);
      setLogList(data);
      let newData = data.reverse();
      setCurrentData(newData);
    }
  };

  useEffect(() => {
    getLogsApiCall();
  }, [currentPage]);

  return (
    <div
      className={
        userDataFromStorage.user_role === "admin"
          ? "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%]  xl:mt-[9%] mt-[20%] bg-blue-50  overflow-hidden"
          : "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[10%]  xl:mt-[5%] mt-[20%] bg-blue-50 overflow-hidden"
      }>
      <p className="text-gray-800 text-[1.8rem] tracking-wider">Log Overview</p>

      {/* search field */}
      <div className="bg-white mt-[2%]">
        <p
          style={{ backgroundColor: coloredTheme }}
          className=" text-white px-[0.5rem] py-[1rem] ">
          Search Fields
        </p>
        <div className="px-[0.5rem] pb-[1rem] mt-2">
          <div className="md:flex justify-start items-center ">
            <p className="w-[25rem]">User Name Contains</p>
            <input
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              type="text"
              className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
            />
          </div>
          <div className="md:flex justify-start items-center mt-6">
            <p className="w-[25rem]">Logged After</p>
            <input
              value={logAfter}
              onChange={(e) => setLogAfter(e.target.value)}
              type="date"
              className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
            />
          </div>
          <div className="md:flex justify-start items-center mt-6">
            <p className="w-[25rem]">Logged Before</p>
            <input
              value={logBefore}
              onChange={(e) => setLogBefore(e.target.value)}
              type="date"
              className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
            />
          </div>
          <div className="md:flex justify-start items-center mt-6">
            <p className="md:w-[25rem]">Logged Action Areas</p>
            <div className="mt-2 md:mt-0  ">
              {/* meals,mileage,mobile,cop,stationary,salary,other */}
              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="radio-buttons-group"
                  className=""
                  row
                  value={actionArea}
                  onChange={(e) => setActionArea(e.target.value)}>
                  <FormControlLabel
                    value={"Claims"}
                    control={<Radio />}
                    label="Claim"
                  />
                  <FormControlLabel
                    value={"Customer"}
                    control={<Radio />}
                    label="Customer"
                  />
                  <FormControlLabel
                    value={"Employee"}
                    control={<Radio />}
                    label="Employee"
                  />
                  <FormControlLabel
                    value={"Loans"}
                    control={<Radio />}
                    label="Loan"
                  />
                  <FormControlLabel
                    value={"Product"}
                    control={<Radio />}
                    label="Product"
                  />
                  <FormControlLabel
                    value={"Transactions"}
                    control={<Radio />}
                    label="Transactions"
                  />
                </RadioGroup>
              </FormControl>
            </div>
          </div>
          <div className="flex justify-start items-center space-x-4">
            <button
              onClick={() => {
                setUserName("");
                setLogAfter("");
                setLogBefore("");
                setActionArea("");
              }}
              style={{ backgroundColor: coloredTheme }}
              className="flex justify-center items-center rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white ">
              <FaUndo className="hidden md:block" />
              <p>Reset Search Fields</p>
            </button>
            <button
              onClick={() => getLogsApiCall()}
              style={{ backgroundColor: coloredTheme }}
              className="flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white">
              <FiSearch className="hidden md:block" />
              <p>Search</p>
            </button>
          </div>
        </div>
      </div>

      <div className="mt-8 bg-white pb-[1.5rem]">
        <div className=" overflow-scroll px-[0.5rem]">
          <table className="md:w-[100%] xl:w-[110%] w-[180%]">
            <thead className="h-[6vh]">
              <tr className="border border-gray-400">
                <th className="text-center  border-r border-gray-400 px-[0.2rem]">
                  Log Number
                </th>
                <th className="text-center  border-r border-gray-400 px-[0.2rem]">
                  User Name
                </th>
                <th className="text-center  border-r border-gray-400 px-[0.2rem]">
                  Log Date & Time
                </th>
                <th className="text-center  border-r border-gray-400 px-[0.2rem]">
                  Log Action Area
                </th>
                <th className="text-center px-[0.2rem]">Log Entry Frequency</th>
              </tr>
            </thead>
            <tbody>
              {currentData.length
                ? currentData.map((x) => {
                    let date = new Date(x?.date_of_operation);
                    let day = String(date?.getUTCDate()).padStart(2, "0");
                    let month = String(date?.getUTCMonth() + 1).padStart(
                      2,
                      "0"
                    );
                    let year = String(date?.getUTCFullYear());
                    let modifiedLogActionDate = `${day}-${month}-${year}`;

                    return (
                      <tr className="border border-gray-400">
                        <td className="text-center border-l border-t border-r border-gray-400 px-[0.2rem]">
                          {x.id_number}
                        </td>
                        <td className="text-center border-l border-t border-r border-gray-400 px-[0.2rem]">
                          {x.user_name}
                        </td>
                        <td className="text-center border-l border-t border-r border-gray-400 px-[0.2rem]">
                          {modifiedLogActionDate}
                        </td>
                        <td className="text-center border-l border-t border-r border-gray-400 px-[0.2rem]">
                          {x.action_area}
                        </td>
                        <td className="text-center border-l border-t border-r border-gray-400 px-[0.2rem]">
                          {x.operation_performed}
                        </td>
                      </tr>
                    );
                  })
                : "No Logs Found"}
            </tbody>
          </table>

          {/* <div className=' mt-8 lg:w-[100%] md:w-[135%] w-[250%]'>
          <button style={{ backgroundColor: coloredTheme }} className='flex justify-center items-center  py-[0.5rem]  text-white  space-x-2 rounded w-[100%]'>
            <IoExitOutline />
            <p>Exit</p>
          </button>
        </div> */}
        </div>

        <div className="flex justify-end space-x-4 items-center mt-4  h-[50%]">
          <button
            className=" px-6 py-2 rounded-lg text-white bg-gray-400 hover:bg-gray-200 shadow-xl hover:text-gray-600 transition duration-[0.5s] tracking-wider"
            onClick={() => setCurrentPage(currentPage - 1)}
            disabled={currentPage === 1}>
            Prev
          </button>
          <button
            className=" px-6 py-2 rounded-lg text-white bg-gray-400 hover:bg-gray-200 shadow-xl hover:text-gray-600 transition duration-[0.5s] tracking-wider"
            onClick={() => setCurrentPage(currentPage + 1)}>
            Next
          </button>
        </div>
      </div>

      <ToastContainer
        newestOnTop={false}
        rtl={false}
        transition={Flip}
        position="top-right"
        autoClose={2000}
        theme="dark"
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={false}
        draggable={true}
        progress={undefined}
        className="text-center"
      />
    </div>
  );
}

export default Logs;
